import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedLocationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12 2.74994C14.188 2.74994 16.2868 3.6188 17.834 5.16595C19.3485 6.68031 20.2142 8.7247 20.249 10.8661C20.2837 13.004 19.4872 15.0719 18.0273 16.6337L17.834 16.8349L13.5908 21.0761C13.187 21.4796 12.6448 21.7145 12.0742 21.7333C11.575 21.7497 11.0865 21.6002 10.6846 21.3105L10.5186 21.1777L10.3926 21.0595L6.16602 16.8339C4.61886 15.2867 3.75 13.188 3.75 10.9999C3.75001 8.81191 4.61884 6.71313 6.16602 5.16595C7.71319 3.61878 9.81197 2.74995 12 2.74994ZM12 7.24994C11.5077 7.24995 11.0202 7.34678 10.5654 7.5351C10.1105 7.72355 9.69685 8.00035 9.34863 8.34857C9.00041 8.69679 8.72361 9.1104 8.53516 9.56537C8.34684 10.0202 8.25001 10.5077 8.25 10.9999C8.25 11.4924 8.3467 11.9805 8.53516 12.4355C8.7236 12.8903 9.0005 13.3032 9.34863 13.6513C9.69685 13.9995 10.1105 14.2763 10.5654 14.4648C11.0203 14.6531 11.5077 14.7499 12 14.7499C12.9946 14.7499 13.9481 14.3546 14.6514 13.6513C15.3546 12.948 15.75 11.9945 15.75 10.9999C15.75 10.0054 15.3546 9.05182 14.6514 8.34857C13.9481 7.64534 12.9945 7.24994 12 7.24994Z",
		stroke: "#333333",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedLocationIcon);
const Memo = memo(ForwardRef);
export default Memo;
